import { useEffect, useState } from "react";
import { Loader2, CalendarDays } from "lucide-react";
import EventosCalendarTab from "../components/eventos/EventosCalendarTab";

const API = process.env.REACT_APP_BACKEND_URL;

// Vista pública de solo lectura (petición usuario 2026-08-27: "compartir link del
// calendario, para que el equipo vea los eventos sin iniciar sesión"). Sin auth,
// reutiliza el mismo componente de calendario que /eventos con los clicks en modo
// no-op (no se puede editar sin login).
export default function EventosCalendarPublicPage() {
  const [eventos, setEventos] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/public/eventos-calendar`)
      .then((r) => r.json())
      .then(setEventos)
      .catch(() => setEventos([]));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 p-6" data-testid="eventos-calendar-public-page">
      <div className="max-w-6xl mx-auto space-y-4">
        <div className="flex items-center gap-2 text-slate-900">
          <CalendarDays className="w-6 h-6 text-emerald-600" />
          <h1 className="text-2xl font-bold">Calendario de Eventos Innovación</h1>
        </div>
        <p className="text-sm text-slate-500">Vista pública de solo lectura · Valoriza Innovation OS</p>
        {eventos === null ? (
          <div className="flex items-center justify-center h-64"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>
        ) : (
          <div className="bg-white rounded-xl border p-4">
            <EventosCalendarTab eventos={eventos} onEventClick={() => {}} />
          </div>
        )}
      </div>
    </div>
  );
}
